import { useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import Idv1 from "../../assets/images/idv1.png";
import Idv2 from "../../assets/images/idv2.png";
import Idv3 from "../../assets/images/idv3.png";
import Idv4 from "../../assets/images/idv4.png";
import Idv5 from "../../assets/images/idv5.png";
import Idv6 from "../../assets/images/idv6.png";
import Idv7 from "../../assets/images/idv7.png";
import Idv8 from "../../assets/images/idv8.png";
import Idv9 from "../../assets/images/idv9.png";
import Idv10 from "../../assets/images/idv10.png";
import Idv11 from "../../assets/images/idv11.png";
import Idv12 from "../../assets/images/idv12.png";

function IdvReport() {
    const [step, setStep] = useState("1");
    const [searchParams] = useSearchParams()

    const navigate = useNavigate();

    const handleRedirect = () => {
        navigate("/idvCompletion", { state: { type: "demo", uid: searchParams.get('uid') } });
    };

    return (
        <div>
            {step === "1" && (
                <div style={{ height: "100vh", width: "100vw", cursor: "pointer", overflow: "hidden" }} onClick={() => setStep("2")}>
                    <img
                        src={Idv1}
                        alt="Select idv1"
                        style={{
                            width: "100%",
                            height: "100%",
                            objectFit: "contain",
                        }}
                    />
                </div>
            )}

            {step === "2" && (
                <div style={{ height: '100vh', width: "100vw", cursor: "pointer", overflow: "hidden" }} onClick={() => setStep("3")}>
                    <img
                        src={Idv2}
                        alt="Select idv2"
                        style={{
                            width: "100%",
                            height: "100%",
                            objectFit: "contain",
                        }}
                    />
                </div>
            )}

            {step === "3" && (
                <div style={{ height: '100vh', width: "100vw", cursor: "pointer", overflow: "hidden" }} onClick={() => setStep("4")}>
                    <img
                        src={Idv3}
                        alt="Select idv3"
                        style={{
                            width: "100%",
                            height: "100%",
                            objectFit: "contain",
                        }}
                    />
                </div>
            )}

            {step === "4" && (
                <div style={{ height: '100vh', width: "100vw", cursor: "pointer", overflow: "hidden" }} onClick={() => setStep("5")}>
                    <img
                        src={Idv4}
                        alt="Select idv4"
                        style={{
                            width: "100%",
                            height: "100%",
                            objectFit: "contain",
                        }}
                    />
                </div>
            )}

            {step === "5" && (
                <div style={{ height: '100vh', width: "100vw", cursor: "pointer", overflow: "hidden" }} onClick={() => setStep("6")}>
                    <img
                        src={Idv5}
                        alt="Select idv5"
                        style={{
                            width: "100%",
                            height: "100%",
                            objectFit: "contain",
                        }}
                    />
                </div>
            )}

            {step === "6" && (
                <div style={{ height: '100vh', width: "100vw", cursor: "pointer", overflow: "hidden" }} onClick={() => setStep("7")}>
                    <img
                        src={Idv6}
                        alt="Select idv6"
                        style={{
                            width: "100%",
                            height: "100%",
                            objectFit: "contain",
                        }}
                    />
                </div>
            )}

            {step === "7" && (
                <div style={{ height: '100vh', width: "100vw", cursor: "pointer", overflow: "hidden" }} onClick={() => setStep("8")}>
                    <img
                        src={Idv7}
                        alt="Select idv7"
                        style={{
                            width: "100%",
                            height: "100%",
                            objectFit: "contain",
                        }}
                    />
                </div>
            )}

            {step === "8" && (
                <div style={{ height: '100vh', width: "100vw", cursor: "pointer", overflow: "hidden" }} onClick={() => setStep("9")}>
                    <img
                        src={Idv8}
                        alt="Select idv8"
                        style={{
                            width: "100%",
                            height: "100%",
                            objectFit: "contain",
                        }}
                    />
                </div>
            )}

            {step === "9" && (
                <div style={{ height: '100vh', width: "100vw", cursor: "pointer", overflow: "hidden" }} onClick={() => setStep("10")}>
                    <img
                        src={Idv11}
                        alt="Select idv11"
                        style={{
                            width: "100%",
                            height: "100%",
                            objectFit: "contain",
                        }}
                    />
                </div>
            )}

            {step === "10" && (
                <div style={{ height: '100vh', width: "100vw", cursor: "pointer", overflow: "hidden" }} onClick={() => setStep("11")}>
                    <img
                        src={Idv12}
                        alt="Select idv12"
                        style={{
                            width: "100%",
                            height: "100%",
                            objectFit: "contain",
                        }}
                    />
                </div>
            )}

            {step === "11" && (
                <div style={{ height: '100vh', width: "100vw", cursor: "pointer", overflow: "hidden" }} onClick={() => setStep("12")}>
                    <img
                        src={Idv9}
                        alt="Select idv9"
                        style={{
                            width: "100%",
                            height: "100%",
                            objectFit: "contain",
                        }}
                    />
                </div>
            )}
            {step === "12" && (
                <div style={{ height: '100vh', width: "100vw", cursor: "pointer", overflow: "hidden" }} onClick={handleRedirect}>
                    <img
                        src={Idv10}
                        alt="Select idv10"
                        style={{
                            width: "100%",
                            height: "100%",
                            objectFit: "contain",
                        }}
                    />
                </div>
            )}
        </div>
    );
}

export default IdvReport;